import 'react';
import EmptyConfirmDialog from '@/adjustment/adjust/support/EmptyConfirmDialog';

export type MpfSourceEmptyConfirmDialogProps = {
    open: boolean;
    message: string;
    redirectCode: string;
    onDismiss: () => void;
    /** 关闭 AdjustTabs / 清理草稿等当前调整相关组件 */
    onCloseAll: () => void;
    onRequestOpenCode?: (code: string) => void;
};

/**
 * PL-AE-MPF / PL-AE-REN 二级菜单所选源 WP 为空时的确认框。
 * Yes → 关闭当前调整流程并打开 redirectCode 底稿；No → 仅关闭当前调整流程（清理草稿与缓存）。
 */
export default function MpfSourceEmptyConfirmDialog({
    open,
    message,
    redirectCode,
    onDismiss,
    onCloseAll,
    onRequestOpenCode,
}: MpfSourceEmptyConfirmDialogProps) {
    const handleCloseAll = () => {
        onDismiss();
        onCloseAll();
    };

    return (
        <EmptyConfirmDialog
            open={open}
            message={message}
            onConfirm={() => {
                handleCloseAll();
                const code = String(redirectCode || '').trim();
                if (code) {
                    onRequestOpenCode?.(code);
                }
            }}
            onCancel={handleCloseAll}
        />
    );
}
